import { Actions } from '../AppReducer'

export default async function logout() {
    localStorage.removeItem('at')
    localStorage.removeItem('rt')
    try { await global.apolloClient.resetStore() }
    catch (error) { console.error(`error resetting Apollo client store: ${error}`)}
    global.uiDispatch(Actions.logOut())
}
